import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from '@ncs/ncs-lib';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root', // or specify a different provider scope if needed
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private router: Router, private eService: EventService) {}

  clearLocalStorageAndNavigate() {
    let _self = this;
    let keySuffix = 'cd' + '-';
    localStorage.removeItem('keySuffix');
    localStorage.removeItem(keySuffix + 'loginId');
    localStorage.removeItem(keySuffix + 'sessionId');
    localStorage.removeItem(keySuffix + 'skey');
    localStorage.removeItem(keySuffix + 'appId');
    localStorage.removeItem(keySuffix + 'roleId');
    localStorage.removeItem(keySuffix + 'userContext');
    _self.eService.menuChanged('');
    _self.eService.sessionEnd('');
    _self.router.navigate(['/login']);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let _self = this;
    const modifiedReq = req.clone({
      // headers: req.headers.set('Authorization', 'Bearer YOUR_TOKEN_HERE'),
      // Add more headers if needed
    });

    // Response Interceptor
    return next.handle(modifiedReq).pipe(
      tap((event) => {
        // put success response logic here
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (
            error.error &&
            error.error.error === 'OOPS! Your session has been expired'
          ) {
            console.log('Your session has expired. Please log in again.');
            _self.clearLocalStorageAndNavigate();
          }
        } else {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            errorMessage = `Client-side error: ${error.error.message}`;
          } else {
            errorMessage = `Server-side error: ${error.status} ${error.message}`;
          }
          console.error(errorMessage);
          //alert(errorMessage);
        }
        // Return an empty observable to complete the request without rethrowing the error
        return new Observable<HttpEvent<any>>();
      })
    );
  }
}
